// Marks an invite URL with the surface that produced it, so the join on the
// other side can be attributed back.
//
// Without this every scan and paste arrives as a generic `invite_link` and the
// festival-mode QR — whose whole premise is that someone standing next to you
// scans it — is indistinguishable from a link dropped in a group chat weeks
// earlier. The funnel would end at "shared" and never reach "worked".
//
// Deliberately NOT named `source`/`utm_source`: GA4 reads those as campaign
// tagging and would rewrite the session's traffic attribution.

const PARAM = 'from'
const FESTIVAL = 'festival'
const EVENT_PARAM = 'event'

/**
 * Tags an invite URL as produced by festival mode's add-people sheet. Pass the
 * `eventId` so the joiner can be dropped straight into that festival after
 * joining, rather than landing on the group/friend page away from the festival.
 */
export function festivalInviteUrl(url: string, eventId?: string): string {
  let out = `${url}${url.includes('?') ? '&' : '?'}${PARAM}=${FESTIVAL}`
  if (eventId) out += `&${EVENT_PARAM}=${encodeURIComponent(eventId)}`
  return out
}

/** True when the current location came from a festival-mode invite. */
export function isFestivalInvite(search: string): boolean {
  return new URLSearchParams(search).get(PARAM) === FESTIVAL
}

/**
 * The festival event a festival-mode invite points at, so the join flow can land
 * the joiner in that festival. Null unless it's a festival invite carrying one.
 */
export function festivalInviteEventId(search: string): string | null {
  const params = new URLSearchParams(search)
  if (params.get(PARAM) !== FESTIVAL) return null
  return params.get(EVENT_PARAM)
}
